/*
 * DEMONTHA — Ağırlık satırını "Açıklama" akordeonundaki tabloya ekler
 * ---------------------------------------------------------------------------
 * Eşi: snippets/dmt-tech-specs.liquid
 *
 * NEDEN VAR
 *   Ağırlık, ürün açıklamasındaki öznitelik tablosunda HİÇ YOK (299 üründen
 *   0'ında). Kaynağı variant.weight (gram). Müşteri isteği üzerine ağırlık
 *   artık açık blokta değil, kapalı "Açıklama" akordeonundaki tablonun
 *   içinde durmalı. Akordeonun içeriğini tema `product.description`'dan
 *   basıyor; Liquid oraya satır ekleyemiyor. Tek yol DOM.
 *
 * DEĞER NEREDEN GELİYOR
 *   Snippet, hesapladığı metni (`14 kg`, `21.5 kg`) `data-dmt-weight`
 *   özniteliğine yazıyor. Bu dosya biçimlendirme YAPMAZ, yalnızca hazır
 *   metni taşır — mağazanın birim ve ondalık biçimi neyse o görünür.
 *
 * NEDEN SONA EKLENİYOR
 *   Snippet, akordeonda gizlenecek satırları `:nth-child()` ile adresliyor
 *   (sıra numaraları Liquid tarafında, aynı HTML ayrıştırılırken ölçülüyor).
 *   Satır BAŞA eklenirse bütün numaralar bir kayar ve yanlış satır gizlenir.
 *   Sona eklemek mevcut satırların sırasını değiştirmez.
 *
 * NEDEN HER SEFERİNDE YENİDEN SORGULAMA
 *   Tema varyant değişiminde `.wt-product__info` kolonunu yeniden basıyor;
 *   yükleme anında yakalanan düğüm referansları kopuk kalır ve eklenen satır
 *   silinir. Hiçbir düğüm önbelleğe alınmıyor, işlem her çağrıda yeniden
 *   yapılıyor ve tekrarlanabilir (var olan satır varsa yenisi eklenmez,
 *   yalnızca metni güncellenir). 21 üründe varyantlar arası ağırlık farklı.
 *
 * JS ÇALIŞMAZSA
 *   Sayfa bozulmaz: açık blok ve akordeon Liquid + CSS ile zaten doğru
 *   çalışır, yalnızca ağırlık satırı görünmez. Gizleme mantığı bilerek
 *   bu dosyaya bağlanmadı — bağlansaydı JS'siz durumda ÇİFT GÖSTERİM
 *   oluşurdu.
 */
(function () {
  'use strict';

  var ETIKET = 'Ağırlık';

  function normalize(metin) {
    return (metin || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr');
  }

  function agirlikMetni() {
    var kaynak = document.querySelector('.wt-product [data-dmt-weight]');
    if (!kaynak) return '';
    return (kaynak.getAttribute('data-dmt-weight') || '').trim();
  }

  function aciklamaTablolari() {
    return document.querySelectorAll(
      '.wt-product .wt-collapse__target--text table.shop_attributes,' +
      ' .wt-product .wt-collapse__target--text table.woocommerce-product-attributes'
    );
  }

  function mevcutSatir(tablo) {
    var satirlar = tablo.rows;
    for (var i = 0; i < satirlar.length; i++) {
      var th = satirlar[i].querySelector('th');
      if (th && normalize(th.textContent) === normalize(ETIKET)) {
        return satirlar[i];
      }
    }
    return null;
  }

  function satirKur(deger) {
    var tr = document.createElement('tr');
    tr.className = 'woocommerce-product-attributes-item dmt-specs__row--weight';

    var th = document.createElement('th');
    th.setAttribute('scope', 'row');
    th.className = 'woocommerce-product-attributes-item__label';
    th.textContent = ETIKET;

    var td = document.createElement('td');
    td.className = 'woocommerce-product-attributes-item__value';
    var p = document.createElement('p');
    p.textContent = deger;
    td.appendChild(p);

    tr.appendChild(th);
    tr.appendChild(td);
    return tr;
  }

  function uygula() {
    var deger = agirlikMetni();
    if (!deger) return; // ağırlığı olmayan ürün: hiçbir şey yapma

    var tablolar = aciklamaTablolari();
    for (var i = 0; i < tablolar.length; i++) {
      var tablo = tablolar[i];
      var eski = mevcutSatir(tablo);

      if (eski) {
        var p = eski.querySelector('td p') || eski.querySelector('td');
        if (p && p.textContent.trim() !== deger) p.textContent = deger;
        continue;
      }

      var govde = tablo.tBodies[0];
      if (!govde) continue;
      govde.appendChild(satirKur(deger));
    }
  }

  // Art arda gelen olaylarda tek çalıştırma (dmt-assurance.js ile aynı desen)
  var bekleyen = null;
  function planla(gecikme) {
    if (bekleyen) clearTimeout(bekleyen);
    bekleyen = setTimeout(function () {
      bekleyen = null;
      uygula();
    }, gecikme);
  }

  document.addEventListener('change', function () { planla(120); }, true);
  document.addEventListener('click', function () { planla(260); }, true);
  window.addEventListener('popstate', function () { planla(0); });
  document.addEventListener('variant:change', function () { planla(0); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', uygula);
  } else {
    uygula();
  }
})();
